function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "42px",
    height: "42px",
    viewBox: "0 0 30 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 41.67,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 0.45098,
      strokeDasharray: "4.17,95.83",
      strokeMiterlimit: 1.5
    },
    d: "M 264.65 693.06593 L 1358.00625 461.265625 ",
    transform: "matrix(0.0186567,0,0,0.0184022,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 41.67,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 0.45098,
      strokeDasharray: "4.17,95.83",
      strokeMiterlimit: 1.5
    },
    d: "M 256.903125 1945.042302 L 1383.55 526.432927 ",
    transform: "matrix(0.0186567,0,0,0.0184022,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 41.67,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 0.45098,
      strokeDasharray: "4.17,95.83",
      strokeMiterlimit: 1.5
    },
    d: "M 1345.8625 1054.988567 L 1434.846875 536.834223 ",
    transform: "matrix(0.0186567,0,0,0.0184022,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 54.17,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 1255.4125 1246.457317 C 1139.8375 1338.370808 993.484375 1393.349085 834.359375 1393.349085 C 498.103125 1393.349085 218.796875 1147.963415 166.034375 826.584604 ",
    transform: "matrix(0.0186567,0,0,0.0184022,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 54.17,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 166.034375 605.185595 C 218.796875 283.806784 498.103125 38.208841 834.359375 38.208841 C 1071.371875 38.208841 1279.909375 160.052591 1401.1375 344.516387 ",
    transform: "matrix(0.0186567,0,0,0.0184022,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(4.705882%,56.470588%,48.235294%)",
      fillOpacity: 1
    },
    d: "M 27.066406 5.917969 C 28.304688 5.917969 29.308594 6.90625 29.308594 8.128906 C 29.308594 9.347656 28.304688 10.339844 27.066406 10.339844 C 25.832031 10.339844 24.828125 9.347656 24.828125 8.128906 C 24.828125 6.90625 25.832031 5.917969 27.066406 5.917969 Z M 27.066406 6.761719 C 26.304688 6.761719 25.683594 7.371094 25.683594 8.128906 C 25.683594 8.882812 26.304688 9.496094 27.066406 9.496094 C 27.832031 9.496094 28.453125 8.882812 28.453125 8.128906 C 28.453125 7.371094 27.832031 6.761719 27.066406 6.761719 Z M 27.066406 6.761719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(4.705882%,56.470588%,48.235294%)",
      fillOpacity: 1
    },
    d: "M 24.808594 19.234375 C 26.046875 19.234375 27.050781 20.222656 27.050781 21.445312 C 27.050781 22.664062 26.046875 23.65625 24.808594 23.65625 C 23.570312 23.65625 22.566406 22.664062 22.566406 21.445312 C 22.566406 20.222656 23.570312 19.234375 24.808594 19.234375 Z M 24.808594 20.078125 C 24.042969 20.078125 23.421875 20.6875 23.421875 21.445312 C 23.421875 22.199219 24.042969 22.8125 24.808594 22.8125 C 25.574219 22.8125 26.195312 22.199219 26.195312 21.445312 C 26.195312 20.6875 25.574219 20.078125 24.808594 20.078125 Z M 24.808594 20.078125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 54.17,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 1288.9125 1054.988567 C 1173.3375 852.481707 955.378125 715.778963 705.803125 715.778963 L 264.65 715.778963 ",
    transform: "matrix(0.0186567,0,0,0.0184022,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 54.17,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 157.03125 826.584604 L 157.03125 1957.566311 ",
    transform: "matrix(0.0186567,0,0,0.0184022,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 54.17,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      stroke: "rgb(4.705882%,56.470588%,48.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 1.5
    },
    d: "M 264.65 2070.919207 L 705.803125 2070.919207 C 1075.978125 2070.919207 1376.640625 1770.342988 1376.640625 1400.141768 L 1376.640625 1386.556402 C 1376.640625 1348.559832 1373.290625 1311.200076 1367.21875 1274.901677 ",
    transform: "matrix(0.0186567,0,0,0.0184022,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(4.705882%,56.470588%,48.235294%)",
      fillOpacity: 1
    },
    d: "M 2.929688 10.960938 C 4.164062 10.960938 5.167969 11.953125 5.167969 13.171875 C 5.167969 14.394531 4.164062 15.382812 2.929688 15.382812 C 1.691406 15.382812 0.6875 14.394531 0.6875 13.171875 C 0.6875 11.953125 1.691406 10.960938 2.929688 10.960938 Z M 2.929688 11.804688 C 2.164062 11.804688 1.542969 12.417969 1.542969 13.171875 C 1.542969 13.925781 2.164062 14.539062 2.929688 14.539062 C 3.691406 14.539062 4.3125 13.925781 4.3125 13.171875 C 4.3125 12.417969 3.691406 11.804688 2.929688 11.804688 Z M 2.929688 11.804688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(4.705882%,56.470588%,48.235294%)",
      fillOpacity: 1
    },
    d: "M 2.929688 35.898438 C 4.164062 35.898438 5.167969 36.886719 5.167969 38.109375 C 5.167969 39.328125 4.164062 40.320312 2.929688 40.320312 C 1.691406 40.320312 0.6875 39.328125 0.6875 38.109375 C 0.6875 36.886719 1.691406 35.898438 2.929688 35.898438 Z M 2.929688 36.742188 C 2.164062 36.742188 1.542969 37.355469 1.542969 38.109375 C 1.542969 38.863281 2.164062 39.476562 2.929688 39.476562 C 3.691406 39.476562 4.3125 38.863281 4.3125 38.109375 C 4.3125 37.355469 3.691406 36.742188 2.929688 36.742188 Z M 2.929688 36.742188 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMini);
export default __webpack_public_path__ + "static/media/LogoMini.773ba0fc72c748e49c957d55c6f84224.svg";
export { ForwardRef as ReactComponent };